module.exports = __webpack_public_path__ + "static/four-trucks-without-tags-b390b4bf0260aa200f8276ec0e7147a3.svg";